import { Component, Inject, inject } from '@angular/core';
import { Api } from '../../services/api';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-mdl-manage-segment',
  imports: [FormsModule, CommonModule, NgSelectModule],
  templateUrl: './mdl-manage-segment.html',
  styleUrl: './mdl-manage-segment.css'
})
export class MdlManageSegment {

  private api = inject(Api);
  public estados: any = [];
  contenido = '';
  tipoEnvio: string = 'now';
  tipoSeleccion: string = 'manual';

  public industrias: any = [];
  
  public prospectos: any = [];
  public contactos: any = [];
  public cuentas: any = [];
  public loadingEntities: boolean = false;
  public ejecutivos: any[] = [];


  public request: any = {
    nombre_segmento: '',
    ejecutivo_id: '2c8b3c88-0b43-4573-9e2d-0a44cef7c6dc',
    tipo_entidad: 'PRO',
    tipo_cliente: '0',
    industria_id: '',
    tipo_negocio: '0',
    fecha_ultima_interaccion: '',
    estado_comercial: '',
    entidades_seleccionadas: [] 
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlManageSegment>,
  ) { 

  }

  ngOnInit(): void {
    this.getCampaignStatus();
    this.getIndustries();
    this.loadEntitiesData(); 
  }

  loadEntitiesData(): void {
    this.loadingEntities = true;
    
    this.api.getProspects().subscribe({
      next: (resp: any) => {
        this.prospectos = resp.prospectos || [];
        this.checkLoadingComplete();
      },
      error: (err: any) => {
        console.error('Error al cargar prospectos:', err);
        this.checkLoadingComplete();
      }
    });

    this.api.getContacts().subscribe({
      next: (resp: any) => {
        this.contactos = resp.contactos || [];
        this.checkLoadingComplete();
      },
      error: (err: any) => {
        console.error('Error al cargar contactos:', err);
        this.checkLoadingComplete();
      }
    });

    this.api.getCuentasByUser().subscribe({
      next: (resp: any) => {
        this.cuentas = resp.cuentas || [];
        this.checkLoadingComplete();
      },
      error: (err: any) => {
        console.error('Error al cargar cuentas:', err);
        this.checkLoadingComplete();
      }
    });
  }

  private loadingCounter = 0;
  checkLoadingComplete(): void {
    this.loadingCounter++;
    if (this.loadingCounter >= 3) { 
      this.loadingEntities = false;
      this.loadingCounter = 0;
    }
  }

  getEntitiesByType(): any[] {
    switch (this.request.tipo_entidad) {
      case 'PRO':
        return this.prospectos;
      case 'CNT':
        return this.contactos;
      case 'ACC':
        return this.cuentas;
      default:
        return [];
    }
  }

  getBindValue(): string {
    switch (this.request.tipo_entidad) {
      case 'PRO':
        return 'prospecto_id';
      case 'CNT':
        return 'contacto_id';
      case 'ACC':
        return 'cuenta_id';
      default:
        return 'id';
    }
  }

  getBindLabel(): string {
    switch (this.request.tipo_entidad) {
      case 'PRO':
        return 'nombre'; 
      case 'CNT':
        return 'nombre'; 
      case 'ACC':
        return 'nombre';
      default:
        return 'nombre';
    }
  }

  onTipoEntidadChange(): void {
    this.request.entidades_seleccionadas = [];
    
    const entities = this.getEntitiesByType();
    if (entities.length === 0) {
      this.loadSpecificEntityType();
    }
  }

  loadSpecificEntityType(): void {
    this.loadingEntities = true;
    
    switch (this.request.tipo_entidad) {
      case 'PRO':
        if (this.prospectos.length === 0) {
          this.api.getProspects().subscribe({
            next: (resp: any) => {
              this.prospectos = resp.data || [];
              this.loadingEntities = false;
            },
            error: (err: any) => {
              console.error('Error al cargar prospectos:', err);
              this.loadingEntities = false;
            }
          });
        } else {
          this.loadingEntities = false;
        }
        break;
        
      case 'CNT':
        if (this.contactos.length === 0) {
          this.api.getContacts().subscribe({
            next: (resp: any) => {
              this.contactos = resp.data || [];
              this.loadingEntities = false;
            },
            error: (err: any) => {
              console.error('Error al cargar contactos:', err);
              this.loadingEntities = false;
            }
          });
        } else {
          this.loadingEntities = false;
        }
        break;
        
      case 'ACC':
        if (this.cuentas.length === 0) {
          this.api.getCuentasByUser().subscribe({
            next: (resp: any) => {
              this.cuentas = resp.data || [];
              this.loadingEntities = false;
            },
            error: (err: any) => {
              console.error('Error al cargar cuentas:', err);
              this.loadingEntities = false;
            }
          });
        } else {
          this.loadingEntities = false;
        }
        break;
    }
    this.getEjecutivos();
  }

  addSegment(): void {
    this.api.showLoading();
    
    if (this.tipoSeleccion === 'manual') {
      this.createManualSegment();
    } else {
      this.createMassiveSegment();
    }
  }

  createManualSegment(): void {
    if (!this.request.entidades_seleccionadas || this.request.entidades_seleccionadas.length === 0) {
      this.api.hideLoading();
      console.error('Debe seleccionar al menos una entidad para el segmento manual');
      return;
    }

    const manualSegmentData = {
      nombre_segmento: this.request.nombre_segmento,
      ejecutivo_id: this.request.ejecutivo_id,
      tipo_entidad: this.request.tipo_entidad,
      entidades_ids: this.getSelectedEntitiesIds()
    };

    console.log('Datos del segmento manual a crear:', manualSegmentData);
    console.log(`Creando segmento manual con ${manualSegmentData.entidades_ids.length} entidades de tipo ${manualSegmentData.tipo_entidad}`);

    this.api.createManualSegment(manualSegmentData).subscribe({
      next: (resp: any) => {
        console.log('Segmento manual creado con éxito:', resp);
        this.api.hideLoading();
        this.mdl.close(true);
      },
      error: (err: any) => {
        this.api.hideLoading();
        console.error('Error al crear el segmento manual:', err);
      }
    });
  }

  createMassiveSegment(): void {
    console.log('Datos del segmento masivo a agregar:', this.request);
    
    this.api.createSegmento(this.request).subscribe({
      next: (resp: any) => {
        console.log('Segmento masivo creado con éxito:', resp);
        this.api.hideLoading();
        this.mdl.close(true);
      },
      error: (err: any) => {
        this.api.hideLoading();
        console.error('Error al crear el segmento masivo:', err);
      }
    });
  }

  getSelectedEntitiesIds(): string[] {
    if (!this.request.entidades_seleccionadas || this.request.entidades_seleccionadas.length === 0) {
      return [];
    }

    console.log('Entidades seleccionadas:', this.request.entidades_seleccionadas);
    console.log('Tipo de entidad:', this.request.tipo_entidad);
    
    const ids = this.request.entidades_seleccionadas;
    
    const idType = this.getBindValue();
    console.log(`Enviando ${ids.length} ${idType}(s):`, ids);
    
    return ids;
  }

  debugSelection(): void {
    console.log('=== DEBUG SELECCIÓN ===');
    console.log('Tipo selección:', this.tipoSeleccion);
    console.log('Tipo entidad:', this.request.tipo_entidad);
    console.log('Entidades disponibles:', this.getEntitiesByType().length);
    console.log('Entidades seleccionadas:', this.request.entidades_seleccionadas);
    console.log('IDs que se enviarían:', this.getSelectedEntitiesIds());
    console.log('========================');
  }

  getIndustries(): void {
    this.api.getIndustrias().subscribe({
      next: (resp: any) => {
        this.industrias = resp.data;
      },
      error: (err: any) => {
        console.error('Error al obtener las industrias:', err);
      }
    });
  }

  getCampaignStatus(): void {
      this.api.getStatusByType({tipo: 'CMP'}).subscribe({
       next: (resp: any) => {
          this.estados = resp.data;
       },
       error: (err: any) => {
         console.error('Error al obtener los estados de campaña:', err);
       }
      }
    );
  }

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image']
    ]
  };

  onContentChanged(event: any) {
    console.log('Contenido cambiado:', event.html);
  }

  onEditorCreated(event: any) {
    console.log('Editor creado:', event);
  }

  obtenerTextoPlano() {
    const temp = document.createElement('div');
    temp.innerHTML = this.contenido;
    return temp.textContent || temp.innerText || '';
  }

  leerData() {
    const textoPlano = this.obtenerTextoPlano();
    console.log('Texto plano:', textoPlano);
  }

  closeMdl(): void {
    this.mdl.close();
  }

  getEnvio(): void {
    console.log('Tipo de envío seleccionado:', this.tipoEnvio);
  }
  

getEjecutivos(): void {
  this.api.getUsers().subscribe({
    next: (resp: any) => {

      if (resp && resp.users) {
        this.ejecutivos = resp.users.filter((u: any) =>
          u.rol?.name?.toLowerCase().includes('ejecutivo')
        );
      } else {
        this.ejecutivos = [];
      }

      console.log('✅ Ejecutivos cargados:', this.ejecutivos);
    },
    error: (err: any) => {
      console.error('❌ Error al obtener ejecutivos:', err);
      this.ejecutivos = [];
    }
  });
}

onTipoClienteChange(): void {
  this.request.tipo_negocio = ''; 
}



}
